export const pageIdSym = Symbol('pageId')
export const contextIdSymbol = Symbol('contextId')
export const PageAssetsLoaderSymbol = Symbol('PageAssetsLoaderSymbol')
export const CssFetcherSymbol = Symbol('CssFetcher')
export const PageResourceFetcherSymbol = Symbol('PageResourceFetcher')
export const PageFeatureLoaderSym = Symbol('PageFeatureLoader')
